<template>
  <!-- 评价成功 -->
  <div class="evaluateSuccess">
     <mt-header title="评价成功">
      <!-- <mt-button slot="right">完成</mt-button> -->
    </mt-header>
    <div class="content">
      <h1><icon name='check-circle'></icon>评价成功</h1>
      <p>感谢你的积极评价，这对专家提升服务水平非常有用！我们期待可以再次为您服务！</p>
    </div>
    <div class="btns">
      <button type="button" @click="zhidao">知道了</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'evaluateSuccess',
  data () {
    return {
      projectid: this.STATE.state.evaluateprojectid,
      loginId: this.STATE.state.loginId
    }
  },
  created(){
    console.log(this.STATE.state.evaluateprojectid)
  },
  methods: {
    goToJob: function () {
      this.$router.push({path: '/myJobs'})
    },
    zhidao () {
      let _this = this
      _this.$router.push({name: 'myProjectDetail', params: { projectId: this.projectid, loginId:this.loginId }})
    }
  }
}
</script>

<style scoped>
.content{
  margin-top: 40%;
}
.content h1{
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}
.content h1 .fa-icon{
  color: #108ee9;
  transform: scale(1.5);
  margin-right:10px;
}
.content p{
  font-size: 14px;
  text-indent: 24px;
  width: 80%;
  margin: 24px auto 0;
}
.btns{
  margin-top: 20%;
  text-align: center;
}
.btns button{
  width: 90%;
  font-size: 14px;
  color: #fff;
  background-color: #108ee9;
  height: 38px;
  border: none;
  outline:none;
  border-radius:20px;
  -webkit-border-radius:20px;
  -moz-border-radius:20px;
}
</style>


// WEBPACK FOOTER //
// evaluateSuccess.vue?c59f2124